module.exports = __webpack_public_path__ + "media/images/user/homepage-4bd82cdca0b9bc785ce0b0caedd1d95d.svg";